export class SC_GeoLocation {
    latitude: number | null;
    longitude: number | null;

    constructor(latitude: number | null = null, longitude: number | null = null) {
        this.latitude = latitude;
        this.longitude = longitude;
    }

    static fromAPI(arrin: number[] | null): SC_GeoLocation | null {
        if (!arrin) {
            return null;
        }
        return new SC_GeoLocation(
            arrin[0],
            arrin[1]
        );
    }

    toArray(): [number | null, number | null] {
        return [this.latitude, this.longitude];
    }

    toAPI(): [number | null, number | null] {
        return [
            this.latitude ?? -360, this.longitude ?? -360,
        ];
    }

    /**
     * Creates a deep copy of this SC_GeoLocation instance
     */
    clone(): SC_GeoLocation {
        return new SC_GeoLocation(
            this.latitude,
            this.longitude,
        );
    }

    /**
     * Merges another SC_GeoLocation object into this one, replacing null fields
     */
    merge(other: SC_GeoLocation): SC_GeoLocation {
        if (other.latitude !== null) this.latitude = other.latitude;
        if (other.longitude !== null) this.longitude = other.longitude;

        return this;
    }

    static basicEmpty(): SC_GeoLocation {
        return new SC_GeoLocation();
    }

    distanceTo(other: SC_GeoLocation): number {
        if (this.latitude === other.latitude && this.longitude === other.longitude) {
            return 0;
        } else {
            const latDelta = (this.latitude - other.latitude) * Math.PI / 180;
            const lonDelta = (this.longitude - other.longitude) * Math.PI / 180;
            const earthRad = 3958.8;
            return earthRad * 2 * Math.asin(Math.sqrt(Math.pow(Math.sin(latDelta / 2), 2) + Math.cos(this.latitude * Math.PI / 180) * Math.cos(other.latitude * Math.PI / 180) * Math.pow(Math.sin(lonDelta / 2), 2)));
        }
    }

    distanceToStr(other: SC_GeoLocation): string {
        if (!this.truthy || !other.truthy) {
            return "Unknown";
        } else if (this.latitude === other.latitude && this.longitude === other.longitude) {
            return "0mi";
        } else {
            return this.distanceTo(other).toFixed(1) + "mi";
        }
    }

    get truthy(): boolean {
        return Boolean(this.latitude && this.longitude) && ((this.latitude || this.longitude) !== -360);
    }

    static fromLeaflet(leafCoords: { lat: number, lng: number } | undefined | null) : SC_GeoLocation {
        if (!leafCoords)
            return this.basicEmpty();
        return new SC_GeoLocation(leafCoords.lat, leafCoords.lng);
    }
}
